import React from 'react';
import {
  Button,
} from '@mui/material';
import ProductList from '../products/top-product-list';

export default function CategoryProductList() {
  return ProductList.map((value) => (
    <li
      className="flex bg-white mx-2 rounded-lg border-2 md:w-full md:px-2 md:py-3 group"
      key={`${value.id}${value.name}`}
    >
      <div className="flex flex-col h-[150px]">
        <img
          src={value.image_url}
          alt={value.name}
          className="object-contain rounded-t-lg w-full
                      xs:h-full
                      sm:h-1/3
                      md:h-[80%]"
          loading="lazy"
        />
        <img
          src={value.brand}
          className="w-full h-[40px] ml-2 object-contain
                    xs:h-[30px] xs:w-1/2
                    sm:h-[30px] sm:w-1/2
                    md:h-[20%] md:w-1/2"
          loading="lazy"
          alt="..."
        />
      </div>
      <div className="p-1 flex flex-col justify-between items-end gap-2 grow">
        <div className="flex flex-col gap-2">
          <div className="flex">
            <p
              className="text-[#364954] font-bold
                        truncate font-serif
                        md:text-lg md:font-normal
                        md:mt-2"
            >
              {value.name}
            </p>
          </div>
          <div className="flex">
            <p className="text-[#364954] truncate font-serif italic text-sm group-hover:hidden">{value.model}</p>
            <button
              type="button"
              className="outline-2 mx-2 bg-darkbg text-sm text-gray-700 py-1 px-3
                    rounded-lg hidden group-hover:block"
            >
              Compare
            </button>
          </div>
        </div>
        <div className="flex justify-end gap-x-1 md:p-0 md:mb-2">
          <Button
            type="button"
            variant="outlined"
            size="small"
            color={value.available ? 'primary' : 'warning'}
          >
            { value.available ? 'available in stock' : 'available in order'}
          </Button>
        </div>
      </div>
    </li>
  ));
}
